export default __webpack_public_path__ + "static/media/ic_close_black_24px.11a56daf.svg";